import { CALC_METHODS } from '../shared/constants';

export const SERVICES_CALC_OPTIONS = [
    { label: 'Flat fee', value: CALC_METHODS.FLAT_FEE },
    { label: '% of order', value: CALC_METHODS.PERCENTAGE_OF_ORDER }
];
